import React, { useMemo } from 'react';
import useAssetGroupSelector from '../../../data/hooks/useAssetGroupSelector';
import useTranslation from '../../utils/Translations/useTranslation';
import SelectBoxFilter from './SelectBoxFilter';
const AssetGroupSelector = ({ name, value, organisationGroupId, onChange, isDisabled, filter, }) => {
    const { t } = useTranslation();
    const { loading, error, assetGroups } = useAssetGroupSelector(organisationGroupId);
    const options = useMemo(() => assetGroups || [], [assetGroups]);
    const disabled = useMemo(() => (isDisabled ? isDisabled(filter) : false), [
        isDisabled,
        filter,
    ]);
    return (<SelectBoxFilter disabled={disabled} error={error} itemValuePropName="id" loading={loading} name={name} options={options} title={t('Asset group')} value={value} onChange={onChange}/>);
};
export default AssetGroupSelector;
